import PilotageTable from './PilotageTable'

export default PilotageTable
